import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Radium from 'higher-order-components/configured-radium/'
import { getState } from 'radium'

/** Renders an animated hamburger icon. */
class AnimatedHamburgerIcon extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClick: PropTypes.func
  }

  setLineStyles(addStyles) {
    addStyles = addStyles || []
    const base = [
      styles.line,
      styles.burger,
      this.getHoverFocus('base') ? styles.lineActive : styles.lineDefault,
      this.props.open ? styles.baseActive : styles.baseDefault
    ]
    return base.concat(addStyles)
  }
  /**
   * @param {string} elementKey - ReactDOM key parameter of element.
   * @returns {boolean} if element is currently focussed or hovered.
   */
  getHoverFocus(elementKey) {
    return getState(this.state, elementKey, ':hover') || getState(this.state, elementKey, ':focus')
  }
  /**
   * @param {object} event - click / keyDown event
   */
  handleInteraction = (event) => {
    if (event.type === 'keydown' && event.key !== 'Enter') return
    this.props.onClick(event)
  }
  /**
   * @param {boolean} open - If true, the hamburger will render in it's open position.
   * @param {function} onClick - function to run on click
   * @returns {ReactElement} React Component
   */
  render() {
    return (
      <span
        data-test="hamburger"
        tabIndex="0"
        key="base"
        style={[styles.base]}
        onClick={this.handleInteraction}
        onKeyDown={this.handleInteraction}>
        <span key="1" style={this.setLineStyles([this.props.open ? styles.firstLine : ''])} />
        <span key="3" style={this.setLineStyles([this.props.open ? styles.secondLine : ''])} />
        <span key="2" style={this.setLineStyles([this.props.open ? styles.thirdLine : ''])} />
      </span>
    )
  }
}

export default Radium(AnimatedHamburgerIcon)

const styles = {
  base: {
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    verticalAlign: 'middle',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
    outline: 0,
    ':hover': {},
    ':focus': {
      outline: 0
    }
  },
  firstLine: {
    transform: 'rotate(135deg)'
  },
  secondLine: {
    opacity: 0
  },
  thirdLine: {
    transform: 'rotate(45deg)'
  },
  baseActive: {
    transition: 'margin .25s .5s, transform .25s .75s, opacity .5s .5s, background .25s',
    margin: '-1px 0 -1px 0'
  },
  baseDefault: {
    transition: 'margin .25s .75s, transform .25s .5s, opacity .5s .5s, background .25s',
    margin: '3px 0 3px 0'
  },
  line: {
    display: 'block',
    height: '2px',
    width: '100%'
  },
  lineActive: {
    background: '#fff'
  },
  lineDefault: {
    background: '#999'
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/animated-hamburger-icon.jsx